import { render, staticRenderFns } from "./WizardButton.vue?vue&type=template&id=21f09af0&scoped=true"
import script from "./WizardButton.vue?vue&type=script&lang=js"
export * from "./WizardButton.vue?vue&type=script&lang=js"
import style0 from "./WizardButton.vue?vue&type=style&index=0&id=21f09af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f09af0",
  null
  
)

export default component.exports